export default "* Pinde – 3 til hver elev";